import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import FeaturedProjects from "../components/FeaturedProjects";
import TechStack from "../components/TechStack";
import ExperienceSection from "../components/ExperienceSection";
import HowIBuildSystems from "./HowBuildSystems";
import ImpactMetrics from "./ImpactMetrics";
import FinalCTA from "./FinalCTA";
import Footer from "../components/Footer";
export default function Home() {
  return (
    <div className="bg-slate-50 text-slate-900 overflow-x-hidden min-h-screen">

      <Navbar />

      <main className="pt-32">
        <Hero />
        <TechStack />
        <FeaturedProjects />
        <ExperienceSection />
        <HowIBuildSystems />
        <ImpactMetrics />
        <FinalCTA />
        <Footer/>

      </main>

    </div>
  );
}